const NUMBER_OF_BANNERS_IN_A_ROW = 3
/* 測試API */
// const API_URL = 'https://api-test.tongli.tw';
// const API_URL = 'http://localhost:61888';
/* 正式 API */
const API_URL = 'https://api.tongli.tw';



// const READER = 'https://tongli-ebook.azurewebsites.net/reader/FireBase3.html?bookID='
const debug = true
const firebaseConfig = {
  apiKey: 'AIzaSyAJbYmo7KyhM_7CDXjjFXnp8bdRTNgbUIE',
  authDomain: 'tongli-book.firebaseapp.com',
  databaseURL: 'https://tongli-book.firebaseio.com',
  projectId: 'tongli-book',
  storageBucket: 'tongli-book.appspot.com',
  messagingSenderId: '1066510659255'
}
const nodeId = {
  index: 0,
  serials: 1,
  comicbook: 2,
  novel: 3
}

// 這個是人氣銷售排行有連載、漫畫、小說
const sellRanking = [1, 2, 3]

const cartStatus = {
  step1: 'list',
  step2: 'purchase',
  step3: 'finish'
}

const qaStatus = {
  tab1: '會員相關問題',
  tab2: '電子書閱讀相關問題',
  tab3: '購物相關問題',
  tab4: '訂單相關問題',
  tab5: '紅利相關問題',
  tab6: '活動相關問題'
}

const purchaseStatus = {
  success: 'success'
}

const paymentStatus = {
  // selectPayment: 'selectPayment',
  step1: 'selectDen',
  // gotoecpay: 'gotoecpay',
  step2: 'finish'
}
// 使用者必須註冊完第一階段，社群註冊之後要驗證完 email, 接著驗證填寫第二階段
const userStatus = {
  anonymous: 'anonymous',
  emailValidate: 'emailValidate',
  userStage1: 'userStage1',
  userStage2: 'userStage2',
  sendedEmail:false,
}
const regStatus={
  reg1 : false,
  reg2 : false,
}
const bookType = {
  index: {
    id: 0,
    name: '首頁',
    new: '最近更新',
    commingsoon: '即將出版',
    special: '特別活動',
    tabDisplay: true
  },
  serials: {
    id: 1,
    name: '連載',
    new: '最近更新',
    commingsoon: '即將出版',
    special: '特別活動',
    leaderboard: '連載排行',
    tabDisplay: false
  },
  comicbook: {
    id: 2,
    name: '漫畫',
    new: '最近更新',
    commingsoon: '即將出版',
    special: '特別活動',
    leaderboard: '漫畫排行',
    tabDisplay: false
  },
  novel: {
    id: 3,
    name: '小說',
    new: '最近更新',
    commingsoon: '即將出版',
    special: '特別活動',
    leaderboard: '小說排行',
    tabDisplay: false
  }
}

const newsOrder = [{
  name: '選擇排序',
  value: 0
}, {
  name: '最新消息',
  value: 1
}, {
  name: '專題企劃',
  value: 2
}, {
  name: '網站活動',
  value: 3
}, {
  name: '問卷投票',
  value: 4
}, {
  name: '活動報導',
  value: 5
}]

const birthYearOptions = [{
  name: '年',
  value: 1
}]

const birthMonthOptions = [{
  name: '月',
  value: 1
}, {
  name: '1月',
  value: '01'
}, {
  name: '2月',
  value: '02'
}, {
  name: '3月',
  value: '03'
}, {
  name: '4月',
  value: '04'
}, {
  name: '5月',
  value: '05'
}, {
  name: '6月',
  value: '06'
}, {
  name: '7月',
  value: '07'
}, {
  name: '8月',
  value: '08'
}, {
  name: '9月',
  value: '09'
}, {
  name: '10月',
  value: '10'
}, {
  name: '11月',
  value: '11'
}, {
  name: '12月',
  value: '12'
}]

const birthDayOptions = [{
  name: '日',
  value: 1
}]
for (let idx = 0; idx < 31; idx++) {
  birthDayOptions.push({
    name: (idx + 1 < 10) ? `0${idx + 1}` : idx + 1,
    value: idx + 1
  })
  // birthDayOptions.push({
  //   name: (idx + 1 < 10) ? `0${idx + 1}` : idx + 1,
  //   value: idx + 1
  // })
}
for (let idx = 2019; idx >= 1900; idx--) {
  birthYearOptions.push({
    name: idx,
    value: idx
  })
  // birthDayOptions.push({
  //   name: (idx + 1 < 10) ? `0${idx + 1}` : idx + 1,
  //   value: idx + 1
  // })
}

const nodeAction = ['News', 'Book', 'SpecialEdit', 'BookGroup', 'Link']

const countryOptions = [{
  name: '國家',
  value: 'cuuntry'
}, {
  name: '台灣',
  value: '台灣'
}, {
  name: '香港',
  value: '香港'
}, {
  name: '澳門',
  value: '澳門'
}]

const sourceTree = {
  search_str: "",
  token: undefined,
  adBlockIsOpen:false,
  isLogin: false,
  isThirdParty: false,
  wallet: {
    coin: 0,
    bouns: 0
  },
  register: {
    email: undefined,
    password: undefined,
    comfirmPassword: undefined,
    nickName: undefined,
    birthYear: 1,
    birthMonth: 1,
    birthDay: 1,
    sex: undefined,
    name: undefined,
    firstname: undefined,
    lastname: undefined,
    idno: undefined,
    countrycode: '+',
    mobile: undefined,
    country: 'cuuntry',
    city: 1,
    area: 1,
    address: undefined,
    first:false,
    newsOrdering: 1
  },
  cities: [],
  countries: {},
  login: {
    email: undefined,
    password: undefined,
  },
  fbCheck:{
    email: undefined,
    password: undefined,
    credential:undefined
  },
  info: {
    file: undefined,
    OldNick: undefined,
    NewNick: undefined,
    OldMobile: undefined,
    NewMobile: undefined,
    OldPassword: undefined,
    NewPassword: undefined,
    NewPassword2: undefined,
    Country: undefined,
    Zipcode: undefined,
    Province: undefined,
    City: undefined,
    District: undefined,
    Address: undefined,
    AvatarURL: undefined,
    imagePreview: undefined
  },
  profile: {
    isPasswordEdit: false,
    isNickNameEdit: false,
    isMobileEdit: false,
    isAddressEdit: false
  },
  Banner:[],
  slides: [],
  // banners: [],
  slidesM: [],
  slidesMNews: [],
  sellShelfs: [],
  sellRanking: [],
  tags:[],
  isShowSerialsSellRanking: false,
  isShowComicSellRanking: false,
  serialsSellRanking: [],
  comicSellRanking: [],
  sellRankings: {
    'serials': {
      data: {},
      display: false
    },
    'comicbook': {
      data: {},
      display: false
    }
  },
  newsLists: [],
  newsListItem: undefined,
  splitList: [],
  newsList: [],
  news: {
    Books: []
  },
  // salesRankings: []
  specialEditSlides: [],
  errors: [],
  // profile
  IsMailNotify:false,
  IsSubscribeNotify:false,
  userInfo: {},
  userMoreInfo: {},
  userAddress: '',
  QALists: [],
  book: undefined,
  comments: [],
  bookVols: [],
  page: undefined,
  books: [],
  breadcrumbs: undefined,
  listName: undefined,
  specialItem: {
    SerialBooks: []
  },
  specialSectionItems: [],
  query: '',
  queryResult: [],
  keywords: [],
  denominations: [],
  selectedDen: undefined,
  userStage: undefined,
  cartStage: undefined,
  paymentStage: undefined,
  cart: {
    status: undefined
  },
  cartActions: {
    selected: []
  },
  payment: {
    status: undefined
  },
  cartList: {
    Books: []
  },
  confirmCartList: [],
  cartStatus: cartStatus,
  paymentStatus: paymentStatus,
  isEnoughShopping: undefined,
  isFinishLoad: [],
  selectedCity: undefined,
  authorPage: undefined,
  author: [],
  serials: [],
  collections: [],
  salesRanking: {},
  initRemodaled: false,
  pageKey: undefined,
  bookType: bookType,
  user: undefined,
  editPwdUser:undefined,
  fileCount: undefined,
  subscribeList: undefined,
  qaStage: qaStatus.tab1,
  bookTags: [],
  cartFinish: undefined,
  birthYearOptions: birthYearOptions,
  birthMonthOptions: birthMonthOptions,
  birthDayOptions: birthDayOptions,
  countryOptions: countryOptions,
  pwVisible: false,
  showSerialsBook: true,
  selectedBookVols: []
}

export {
  NUMBER_OF_BANNERS_IN_A_ROW,
  API_URL,
  READER,
  firebaseConfig,
  sourceTree,
  nodeId,
  userStatus,
  regStatus,
  bookType,
  cartStatus,
  paymentStatus,
  sellRanking,
  purchaseStatus,
  debug,
  qaStatus,
  newsOrder,
  birthYearOptions,
  birthMonthOptions,
  birthDayOptions,
  nodeAction
}



// WEBPACK FOOTER //
// ./src/config.js